export default "__VITE_ASSET__CvprzknI__"